export const capitalize = (s: string) => s && s[0].toUpperCase() + s.slice(1);

export const toBase64 = (payload: object) => {
	return Buffer.from(JSON.stringify(payload)).toString('base64');
};

export const fromBase64 = (payload: string) => {
	return JSON.parse(Buffer.from(payload, 'base64').toString('utf8'));
};
